/* global Sys, Core */
Sys.ns("Core");

/**
 * The Custom Messages module.
 *
 * @class Core.CustomMessages
 * @extends Core.Module
 */
Core.CustomMessages = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.CustomMessages.superclass.constructor.apply(this, arguments);
    },

    /**
     * @inheritdoc
     */
    getStateChanges: function() {
        var model = this.model;

        return {
            showingCustomMessages: {
                state: {
                    name: "ShowingCustomMessages",
                    execute: function() {
                        // stub
                    },
                    waitEvents: {
                        "notify:customMessages.messagesClosed": false
                    }
                }
            },
            delayBeforeShowingMessages: {
                state: {
                    name: "DelayBeforeShowingMessages",
                    execute: function() {
                        // stub
                    },
                    waitEvents: {
                        "notify:customMessages.delayComplete": false
                    }
                }
            },
            idle: {
                waitEvents: [
                    "notify:customMessages.messagesClosed"
                ]
            },
            beforeStopping: {
                queue: [
                    function(env) {
                        if (model.hasImmediate() || !model.readData("shouldShowDialogs")) {
                            env.stateHandler.pushState(env.states.showingCustomMessages);
                        }
                    }
                ]
            },
            setupGame: {
                waitEvents: [
                    "notify:customMessages.ready"
                ]
            },
            noWinPresentation: {
                queue: [
                    function(env) {
                        if (model.hasDialogs() || !model.readData("shouldShowDialogs")) {
                            env.stateHandler.pushState(env.states.delayBeforeShowingMessages);
                        }
                    }
                ]
            }
        };
    },

    /**
     * @inheritdoc
     */
    getMixinDependencies: function() {
        return [
            "userInput"
        ];
    },

    /**
     * @inheritdoc
     */
    getDefaultMVCClasses: function() {
        return {
            controller: Core.CustomMessagesController,
            model: Core.CustomMessagesModel
        };
    }
};

Core.CustomMessages = Sys.extend(Core.Module, Core.CustomMessages, "Core.CustomMessages");
